<section class="bg-white py-8 antialiased md:py-16">
  <section class="mx-auto max-w-2xl px-4 2xl:px-0" *ngIf="loadingOrder">
    <nz-skeleton class="w-full" [nzActive]="true"></nz-skeleton>
    <nz-skeleton [nzActive]="true"></nz-skeleton>
    <nz-skeleton [nzActive]="true"></nz-skeleton>
  </section>
  <div *ngIf="!loadingOrder" class="mx-auto max-w-2xl px-4 2xl:px-0">

    <!-- Success -->
    <div  *ngIf="order.status === orderStatusEnum.COMPLETED">
        <h2 class="text-xl font-semibold text-gray-900 sm:text-2xl mb-2">
          {{ isWalletTopUp ? 'Wallet topped up!' : 'Thanks for your order!' }}
        </h2>
        <p class="text-gray-500 mb-6 md:mb-8" *ngIf="!isWalletTopUp">
          Your order
          <span class="font-medium text-gray-900">#{{ orderNumber }}</span> has been
          successful. Check your email for your tickets and order details,
          alternatively you can download them here.
        </p>
        <p class="text-gray-500 mb-6 md:mb-8" *ngIf="isWalletTopUp">
          Your top-up
          <span class="font-medium text-gray-900">#{{ orderNumber }}</span> was successful and the
          funds are now on your ticket's wallet. You can see the balance under
          <a routerLink="/my-tickets" class="underline text-gray-900">My Tickets</a>.
        </p>

    </div>


    <!-- Failure -->
    <!--
      FAILED belongs here. It is what the gateway leaves behind when a payment is cancelled or
      declined, and it matched no branch at all — the customer saw payment details with no heading
      and no explanation of what had happened.
    -->
    <div *ngIf="order.status === orderStatusEnum.CANCELLED || order.status === orderStatusEnum.CLOSED || order.status === orderStatusEnum.FAILED">
        <h2 class="text-xl font-semibold text-red-600 sm:text-2xl mb-2">
          {{ isWalletTopUp ? 'Top-up not completed' : 'Order Cancelled' }}
        </h2>
        <p class="text-gray-500 mb-6 md:mb-8" *ngIf="!isWalletTopUp">
          We're sorry, but your order
          <span class="font-medium text-gray-900">#{{ orderNumber }}</span> could not be completed.
          Please check your payment details and try again.
          If you continue to experience issues, contact our support team for assistance.
        </p>
        <p class="text-gray-500 mb-6 md:mb-8" *ngIf="isWalletTopUp">
          Your top-up
          <span class="font-medium text-gray-900">#{{ orderNumber }}</span> was not completed, so
          nothing has been charged and your wallet balance is unchanged. You can start another
          top-up from <a routerLink="/my-tickets" class="underline text-gray-900">My Tickets</a>.
          If you continue to experience issues, contact our support team for assistance.
        </p>
      </div>

      <!-- Pending -->

      <!-- RESERVED is in the enum but was handled nowhere: held, awaiting payment, i.e. pending. -->
      <div *ngIf="order.status === orderStatusEnum.INITIATED || order.status === orderStatusEnum.IN_PROGRESS || order.status === orderStatusEnum.RESERVED">
        <h2 class="text-xl font-semibold text-yellow-600 sm:text-2xl mb-2">
          {{ isWalletTopUp ? 'Top-up processing' : 'Order created' }}
        </h2>
        <p class="text-gray-500 mb-6 md:mb-8" *ngIf="!isWalletTopUp">
          Your order
          <span class="font-medium text-gray-900">#{{ orderNumber }}</span> is still being processed.
          Please visit your cart to complete the order.
          If you are facing any challenges, please contact our support team.
        </p>
        <p class="text-gray-500 mb-6 md:mb-8" *ngIf="isWalletTopUp">
          Your top-up
          <span class="font-medium text-gray-900">#{{ orderNumber }}</span> is still being processed.
          Your wallet balance will update once the payment clears — check it under
          <a routerLink="/my-tickets" class="underline text-gray-900">My Tickets</a> shortly.
          If you are facing any challenges, please contact our support team.
        </p>
      </div>

    <div *ngIf="order.paymentTransaction"
      class="space-y-4 sm:space-y-2 rounded-lg border border-gray-100 bg-gray-50 p-6 mb-6 md:mb-8"
    >
      <dl class="sm:flex items-center justify-between gap-4">
        <dt class="font-normal mb-1 sm:mb-0 text-gray-500">Date</dt>
        <!--
          dateTimeOfPayment arrives as epoch milliseconds, so unpiped it rendered as a raw
          1788351235331 on the receipt. 'medium' keeps the time, which is the part a customer
          matching this against a bank or Ecocash notification actually needs.
        -->
        <dd class="font-medium text-gray-900 sm:text-end">
          {{ order.paymentTransaction.dateTimeOfPayment | date: 'medium' }}
        </dd>
      </dl>
      <dl class="sm:flex items-center justify-between gap-4">
        <dt class="font-normal mb-1 sm:mb-0 text-gray-500">Payment Ref</dt>
        <dd class="font-medium text-gray-900 sm:text-end">
            {{order.paymentTransaction.referenceNumber}}

        </dd>
      </dl>
      <dl class="sm:flex items-center justify-between gap-4">
        <dt class="font-normal mb-1 sm:mb-0 text-gray-500">Payment Method</dt>
        <dd class="font-medium text-gray-900 sm:text-end">
            <nz-tag [nzColor]="'#333333'">{{order.paymentMethod}}</nz-tag>

        </dd>
      </dl>
      <dl class="sm:flex items-center justify-between gap-4">
        <dt class="font-normal mb-1 sm:mb-0 text-gray-500">Amount</dt>
        <dd class="font-medium text-gray-900 sm:text-end">
          {{order.paymentTransaction.amount | currency}}
          {{order.paymentTransaction.currencyCode }}
        </dd>
      </dl>
      <dl class="sm:flex items-center justify-between gap-4">
        <dt class="font-normal mb-1 sm:mb-0 text-gray-500">Transaction Status</dt>
        <dd class="font-medium text-gray-900 sm:text-end">
            <nz-tag nzColor="success" *ngIf="order.paymentTransaction.transactionStatus === transactionStatusEnum.SUCCESS">
                <span nz-icon nzType="check-circle"></span>
                <span>success</span>
              </nz-tag>


              <nz-tag nzColor="warning" *ngIf="order.paymentTransaction.transactionStatus === transactionStatusEnum.PENDING">
                <span nz-icon nzType="exclamation-circle"></span>
                <span>pending</span>
              </nz-tag>

              <nz-tag nzColor="error" *ngIf="order.paymentTransaction.transactionStatus === transactionStatusEnum.FAILED">
                <span nz-icon nzType="close-circle"></span>
                <span>failed</span>
              </nz-tag>
        </dd>
      </dl>
    </div>

    <!-- A wallet top-up issues no tickets, so this whole block would render as empty padding. -->
    <div *ngIf="!isWalletTopUp">
      <div class="container mx-auto px-4 py-8">
        <div class="grid grid-cols-1 gap-4">
          <!-- Iterate over tickets -->
          <div
            *ngFor="let ticket of tickets"
            class="p-4 bg-white shadow-md rounded-lg border border-gray-200"
          >
            <h2 class="text-lg font-semibold text-gray-800">
              {{ ticket.ticketTypeName }}
            </h2>
            <p class="text-sm text-gray-600">
              <span class="font-semibold">Purchased by: </span>
              {{ ticket.purchasedBy }}
            </p>
            <p class="text-sm text-gray-600">
              <span class="font-semibold">Date of Purchase: </span>
              {{ ticket.dateOfPurchase | date: 'medium' }}
            </p>
            <p class="text-sm text-gray-600">
              <span class="font-semibold">Amount: </span
              >{{ ticket.amount | currency : '' }} {{ ticket.currencyCode }}
            </p>
            <p *ngIf="hasSelectedAddOns(ticket)" class="text-xs text-gray-500">
              <span class="font-semibold">Add-ons: </span>
              {{ addOnsText(ticket) }}
            </p>
            <p class="text-sm text-gray-600">
              <span class="font-semibold">Status: </span
              >{{ ticket.ticketStatus }}
            </p>

            <div class="mt-4 flex space-x-4">
              <a
                [href]="
                  apiUrl +
                  '/' + microservice.ETICKETING + '/opn/v2/download-tickets?uid=' +
                  ticket.uid
                "
                target="_blank"
                class="px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-700 transition-colors"
              >
                View
              </a>
              <a
                [href]="
                  apiUrl +
                  '/' + microservice.ETICKETING + '/opn/v2/download-tickets?uid=' +
                  ticket.uid
                "
                download
                class="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-500 transition-colors"
              >
                Download
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex items-center space-x-4">
      <button
        nzType="primary"
        nz-button
        nzSize="large"
        class="my-4"
        (click)="returnToShop()"
      >
        {{ isWalletTopUp ? 'Back to My Tickets' : 'Return to shopping' }}
      </button>
    </div>
  </div>
</section>
